import React from 'react';
import Button from '../../components/Button/Button';
import FontAwesomeIcon from '../Icon/FontAwesomeIcon';
import './calendar-header.scss';
import ModernDatePicker from 'src/components/SharedComponents/ModernDatePicker/ModernDatePicker';

interface CalendarHeaderProps {
  fromDate: Date;
  toDate: Date;
  onFromDateChange: (date: Date) => void;
  onToDateChange: (date: Date) => void;
  isTodaySelected: boolean;
  onGoToToday: () => void;
  error: string | null;
}

const CalendarHeader = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  isTodaySelected,
  onGoToToday,
  error,
}: CalendarHeaderProps) => {
  // Handle date changes with null safety.
  const handleFromDateChange = (date: Date | null) => {
    if (date) {
      onFromDateChange(date);
    }
  };

  const handleToDateChange = (date: Date | null) => {
    if (date) {
      onToDateChange(date);
    }
  };

  return (
    <div className="calendar-header">
      <h1 className="heading_headline">Calendar</h1>
      {error && <div className="error-message">{error}</div>}
      <div className="calendar-controls">
        <div className="date-input">
          <ModernDatePicker
            label="From Date"
            value={fromDate}
            onChange={handleFromDateChange}
            fullWidth={false}
          />
        </div>
        <div className="date-input">
          <ModernDatePicker
            label="To Date"
            value={toDate}
            onChange={handleToDateChange}
            fullWidth={false}
          />
        </div>
        {!isTodaySelected && (
          <div className="today-button">
            <Button
              color="teal"
              label="Set End: Today"
              onClick={onGoToToday}
              icon={
                <FontAwesomeIcon
                  glyph="calendar-day"
                  weight="light"
                  size="small"
                />
              }
              size="small"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarHeader;
